import React from "react";

const RootContext = React.createContext({});
export default RootContext;
